import React, { useMemo } from 'react';
import styled from 'styled-components';
import { Box, Checkbox, CircularProgress, Table, TableBody, TableCell, TableContainer, TableRow } from '@material-ui/core';
import { formatDate } from '@sierralabs/core';
import { TaskStatusLabel } from '@sierralabs/workflow-ui';
import { useFileVersionLabel } from '../hooks/useFileVersionLabel';
import DocumentListHead from './DocumentListHead';
import DocumentUserLink from './DocumentUserLink';
import FileIcon from './FileIcon';
const StyledTable = styled(Table) `
  th,
  td {
    .align-icon {
      display: flex;
      align-items: center;
      .file-name {
        margin-left: 5px;
      }
    }
    &:first-child {
      padding-left: 10px;
    }
    &:last-child {
      padding-right: 10px;
    }
  }
  .file-icon {
    width: 20px;
  }
`;
const DocumentList = props => {
    const { files, isLoading, selectedIds, order, orderBy, setOrder, setOrderBy, onRowClick, onRowDoubleClick, onSelectionChange } = props;
    const checkboxProps = useMemo(() => {
        const fileIds = files.map(file => file.id);
        const checked = selectedIds.length > 0 && selectedIds.every(id => fileIds.includes(id));
        const indeterminate = selectedIds.length > 0 && !checked;
        return { checked, indeterminate };
    }, [files, selectedIds]);
    const onSelectToggle = (selectedId, checked) => {
        const selection = [...selectedIds];
        const existingIndex = selection.indexOf(selectedId);
        const exists = existingIndex > -1;
        if (checked) {
            !exists && selection.push(selectedId);
        }
        else if (exists) {
            selection.splice(existingIndex, 1);
        }
        onSelectionChange(selection);
    };
    return (React.createElement(TableContainer, null,
        React.createElement(StyledTable, { stickyHeader: true },
            React.createElement(DocumentListHead, { order: order, orderBy: orderBy, checkboxProps: checkboxProps, onSort: property => {
                    const isAsc = orderBy === property && order === 'ASC';
                    setOrder(isAsc ? 'DESC' : 'ASC');
                    setOrderBy(property);
                }, onToggleAll: checked => {
                    const partial = checked && !checkboxProps.checked;
                    const selection = partial ? files.map(file => file.id) : [];
                    onSelectionChange(selection);
                } }),
            React.createElement(TableBody, null,
                isLoading && (React.createElement(TableRow, null,
                    React.createElement(TableCell, { colSpan: 7 },
                        React.createElement(Box, { height: 300, width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' },
                            React.createElement(CircularProgress, null))))),
                files.map(file => (React.createElement(DocumentListItem, { key: file.id, file: file, isSelected: selectedIds.includes(file.id), onRowClick: () => onRowClick === null || onRowClick === void 0 ? void 0 : onRowClick(file), onRowDoubleClick: () => onRowDoubleClick === null || onRowDoubleClick === void 0 ? void 0 : onRowDoubleClick(file), onSelectToggle: checked => onSelectToggle(file.id, checked) })))))));
};
export default DocumentList;
export const DocumentListItem = (props) => {
    var _a;
    const { file, isSelected = false, onRowClick, onRowDoubleClick, onSelectToggle } = props;
    const { version } = useFileVersionLabel(file);
    return (React.createElement(TableRow, { hover: true, selected: isSelected, onClick: onRowClick, onDoubleClick: onRowDoubleClick },
        React.createElement(TableCell, { padding: 'checkbox' },
            React.createElement(Checkbox, { color: 'primary', checked: isSelected, onChange: (_, checked) => onSelectToggle === null || onSelectToggle === void 0 ? void 0 : onSelectToggle(checked) })),
        React.createElement(TableCell, null,
            React.createElement("div", { className: 'align-icon' },
                React.createElement(FileIcon, { path: file.path, isFolder: file.isFolder, extension: file.extension, className: 'file-icon' }),
                React.createElement("span", { className: 'file-name' }, file.name))),
        React.createElement(TableCell, null, !file.isFolder && (((_a = file.task) === null || _a === void 0 ? void 0 : _a.key) || `DOC-${file.id}`)),
        React.createElement(TableCell, null, version),
        React.createElement(TableCell, null,
            React.createElement(DocumentUserLink, { user: file.modifiedBy })),
        React.createElement(TableCell, null, formatDate(file.modified)),
        React.createElement(TableCell, null, !file.isFolder && React.createElement(TaskStatusLabel, { task: file.task }))));
};
//# sourceMappingURL=DocumentList.js.map